import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  data() {
    return {
      loadingSeminarPackages: [],
    };
  },
  computed: {
    ...mapFields("seminarPackage", {
      seminarIds: "allIds",
      seminarIdsCached: "cacheAllIds",
    }),
    ...mapGetters("seminarPackage", {
      findSeminarPackage: "find",
    }),
  },
  methods: {
    ...mapActions("seminarPackage", {retrieveSeminarPackage: "load"}),
    resolveSeminarPackage(itemId) {
      if (!this.isSeminarPackageLoaded(itemId) && !this.loadingSeminarPackages.includes(itemId)) {
        this.loadingSeminarPackages.push(itemId);
        this.retrieveSeminarPackage(decodeURIComponent(itemId));
      }
      return this.findSeminarPackage(itemId);
    },
    resolveSeminarPackages(itemIds) {
      if (typeof itemIds === "undefined") {
        return [];
      }
      return itemIds.map((itemId) => {
        return this.resolveSeminarPackage(itemId);
      }).filter(e => e);
    },
    getSeminarPackageItem(seminarIri, type) {
      if (seminarIri !== null) {
        let seminarPackage = this.resolveSeminarPackage(seminarIri);
        if (seminarPackage) {
          return seminarPackage[type];
        }
      }
      return '';
    },
    isSeminarPackageLoaded(itemId) {
      return this.seminarIdsCached.includes(itemId);
    },
    isSeminarPackageSetLoaded(itemIds) {
      return itemIds.every(itemId => this.isSeminarPackageLoaded(itemId));
    },
    resolveSeminarPackageAsync(itemId) {
      const poll = resolve => {
        if (this.isSeminarPackageLoaded((itemId))) {
          resolve(this.resolveSeminarPackage(itemId));
        } else {
          this.resolveSeminarPackage(itemId);
          setTimeout(() => poll(resolve), 400);
        }
      }
      return new Promise(poll);
    },
    resolveSeminarPackagesAsync(itemIds) {
      const poll = resolve => {
        if (this.isSeminarPackageSetLoaded((itemIds))) {
          resolve(this.resolveSeminarPackages(itemIds));
        } else {
          this.resolveSeminarPackage(itemIds);
          setTimeout(() => poll(resolve), 400);
        }
      }
      return new Promise(poll);
    },
  }
};
